import React, { useState } from "react";
import { fileToResizedDataUrl } from "../../photoUtils";
import { PhotoPickerButtons } from "./PhotoPickerButtons";
import { useLanguage } from "../../i18n";

// Used on the "Add Property" form, before the property has an id to upload
// against. Holds resized photos as data URLs in local state; the form
// uploads them to the real endpoint right after the property is created.
export function PhotoStager({ photos, onChange }: { photos: string[]; onChange: (photos: string[]) => void }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const { t } = useLanguage();

  async function handleFiles(files: FileList | null) {
    if (!files || files.length === 0) return;
    setBusy(true);
    setError("");
    try {
      const added: string[] = [];
      for (const file of Array.from(files)) {
        if (!file.type.startsWith("image/")) continue;
        added.push(await fileToResizedDataUrl(file));
      }
      onChange([...photos, ...added]);
    } catch (err) {
      setError(err instanceof Error ? err.message : t("photoStager.couldNotRead"));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="field">
      <label>{t("photoStager.photosLabel")}</label>
      {error && <div className="error-banner">{error}</div>}
      <div className="photo-grid">
        {photos.map((dataUrl, i) => (
          <div className="photo-thumb" key={i}>
            <img src={dataUrl} alt="" />
            <button
              type="button"
              className="photo-thumb-remove"
              onClick={() => onChange(photos.filter((_, idx) => idx !== i))}
              aria-label={t("photoStager.removePhotoAria")}
              title={t("photoStager.removePhotoAria")}
            >
              &times;
            </button>
          </div>
        ))}
        <PhotoPickerButtons busy={busy} onFiles={handleFiles} />
      </div>
    </div>
  );
}
